export default __webpack_public_path__ + "static/media/triiboLojaIos.ad224771.png";